import { permissoes, routesNames } from '@/core/constants'
import PenalidadesView from '@/views/pages/ata/acessar/penalidades/PenalidadesView.vue'

export default {
	name: routesNames.ATA.ATA_ACESSAR_PENALIDADES_VIEW,
	path: 'penalidades/',
	component: PenalidadesView,
	meta: {
		page: {
			title: 'Ata de Registro de Preço',
			subtitle: 'Infrações e Sanções',
		},
		requiresAuth: true,
		authorities: [permissoes.ataVisualizar, permissoes.ataEditar],
	},
}
